import { Accessor, For, JSX, ParentProps, Show, Signal, createSignal } from 'solid-js'
import styles from './st-combobox.module.css'
import Flexbox from '../st-flexbox/st-flexbox';
import Input from '../st-input/st-input';

export interface ComboboxProps<T extends readonly any[]> {
    items: T;
    value: Signal<T[number] | undefined>;
    filter?: Signal<string>
    filterIcon?: string
    fallback?: JSX.Element;
}

export default function Combobox<T extends readonly any[] = any[], U extends JSX.Element = JSX.Element>(props: ComboboxProps<T> & {
    children: (item: T[number], index: Accessor<number>) => U;
}) {
    const [value, setValue] = props.value;

    return <div class={styles.combobox} >
        <Show when={props.filter}>
            <Input focused value={props.filter!} icon={props.filterIcon ?? 'fas fa-filter'} />
        </Show>
        <Flexbox dir="vertical" role="listbox">
            <For each={props.items} fallback={props.fallback} >{(it, idx) =>
                <Flexbox.Item class={styles.item} role="listitem" onClick={() => setValue(it)} >
                    {props.children(it, idx)}
                </Flexbox.Item>
            }</For>
        </Flexbox>
    </div>
}

class ComboboxDefaultProps implements ComboboxProps<any[]> {
    items: any[] = [];
    value: Signal<any | undefined> = createSignal('');
    children: (item: any, index: Accessor<number>) => any = () => { };
}

Combobox.defaultProps = new ComboboxDefaultProps();
